<template>
  <div v-if="labelPosition==='top'" class="recommd-comp" v-loading="loading" :class="recommdTip ? 'active' : ''">
    <div class="comp-box">
      <i class="el-icon-close" @click="$emit('recommdTipChange')"></i>
      <h4 style="text-align: center;margin-bottom: 12px;">我要推荐供应商</h4>
      <p class="recommd-desc">如果您查不到需要使用的产品三维模型，或者您的供应商尚未进入平台，那么您可以将该供应商信息填写到如下表格中，平台客服人员会立即与您核实诉求，并积极联系该供应商将其产品模型上传到平台，以使您能正常下载，一旦确认信息准确，您将直接获得超级会员权限，可以任意下载平台上所有模型。</p>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="150px"
        class="demo-ruleForm"
        size="small"
        :label-position="labelPosition"
      >
        <el-form-item label="供应商公司名称" prop="compName">
          <el-input v-model="ruleForm.compName" placeholder="请输入您需要的供应商公司名称"></el-input>
        </el-form-item>
        <el-form-item label="供应商负责人姓名" prop="userName">
          <el-input v-model="ruleForm.userName" placeholder="请输入供应商负责人姓名"></el-input>
        </el-form-item>
        <el-form-item label="供应商负责人电话" prop="phone">
          <el-input v-model="ruleForm.phone" placeholder="请输入供应商负责人电话"></el-input>
        </el-form-item>
        <el-form-item label="供应商负责人职位" prop="position">
          <el-input v-model="ruleForm.position" placeholder="请输入供应商负责人职位"></el-input>
        </el-form-item>
        <!-- <el-form-item label="企业位置" prop="addressObj">
          <el-cascader
            :props="cascaderProps"
            :options="options"
            size="mini"
            style="width: 100%"
            v-model="ruleForm.addressObj">
          </el-cascader>
        </el-form-item> -->
        <el-form-item label="该供应商主要给我提供的产品是" prop="products">
          <el-input v-model="ruleForm.products" placeholder="请输入供应商提供的产品名称"></el-input>
        </el-form-item>
      </el-form>
      <div class="tip-text">准确提交信息，平台核实后将自动成为超级会员！</div>
      <div class="submit-btn">
        <el-button type="primary" @click="_clueCreat" size="small">确认提交</el-button>
        <el-button type="primary" @click="goChat" size="small">联系客服申请会员</el-button>
      </div>
    </div>
  </div>
  <div v-else class="recommd-comp-left" v-loading="loading">
    <div class="comp-box">
      <!-- <i class="el-icon-close" @click="$emit('recommdTipChange')"></i> -->
      <!-- <h4 style="text-align: center;margin-bottom: 12px;">我要推荐供应商</h4> -->
      <p class="recommd-desc">如果您查不到需要使用的产品三维模型，或者您的供应商尚未进入平台，那么您可以将该供应商信息填写到如下表格中，平台客服人员会立即与您核实诉求，并积极联系该供应商将其产品模型上传到平台，以使您能正常下载，一旦确认信息准确，您将直接获得超级会员权限，可以任意下载平台上所有模型。</p>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="210px"
        class="demo-ruleForm"
        size="small"
        :label-position="labelPosition"
      >
        <el-form-item label="供应商公司名称" prop="compName">
          <el-input v-model="ruleForm.compName" placeholder="请输入您需要的供应商公司名称" style="max-width: 300px;"></el-input>
        </el-form-item>
        <el-form-item label="供应商负责人姓名" prop="userName">
          <el-input v-model="ruleForm.userName" placeholder="请输入供应商负责人姓名" style="max-width: 300px;"></el-input>
        </el-form-item>
        <el-form-item label="供应商负责人电话" prop="phone">
          <el-input v-model="ruleForm.phone" placeholder="请输入供应商负责人电话" style="max-width: 300px;"></el-input>
        </el-form-item>
        <el-form-item label="供应商负责人职位" prop="position">
          <el-input v-model="ruleForm.position" placeholder="请输入供应商负责人职位" style="max-width: 300px;"></el-input>
        </el-form-item>
        <el-form-item label="该供应商主要给我提供的产品是" prop="products">
          <el-input v-model="ruleForm.products" placeholder="请输入供应商提供的产品名称" style="max-width: 300px;"></el-input>
        </el-form-item>
      </el-form>
      <div class="tip-text">准确提交信息，平台核实后将自动成为超级会员！</div>
      <div class="submit-btn">
        <el-button type="primary" @click="_clueCreat" size="small">确认提交</el-button>
        <el-button type="primary" @click="goChat" size="small">联系客服申请会员</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import {Message} from 'element-ui'
import zones_data from '@/components/region-picker';
import {Listener} from '@/libs'
import {ClueService,ChatService} from '@/service'
import { Category } from '@/libs';

export default {
  props: {
    recommdTip: { default: false },
    labelPosition: { default: 'top' },
  },
  data() {
    return {
      options: zones_data.zones_tree,
      loading: false,
      cascaderProps: {
        value: 'name',
        label: 'name',
      },
      ruleForm: {
        compName: '',
        userName: '',
        phone: '',
        position: '',
        products: '',
        addressObj: {},
      },
      rules: {
        compName: [{required: true, message: "请输入企业名称", trigger: "blur"}],
        userName: [{required: true, message: "请输入姓名", trigger: "blur"}],
        phone: [{required: true, message: "请输入电话", trigger: "blur"}],
      },

      cleanupBodyEvent: null,  // 用于保存清理函数
    }
  },
  mounted() {
    if(this.labelPosition !== 'left') {   
      // 弹框列表出现后，点击其他任意位置，弹框缩回
      this.cleanupBodyEvent = Listener.bodyEventDelegate([], 'recommd-comp', (obj) => {
        if (obj.type === 'out_click') {
          !obj.className.includes('att-rec-btn') && this.$emit('recommdTipChange', false)
        }
      });
    }
  },
  beforeDestroy() {
    // 组件销毁前，清理事件监听
    if (this.cleanupBodyEvent) {
      this.cleanupBodyEvent();
    }
  }, 
  methods: {
    _clueCreat() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.loading = true;
          const {compName, products, userName, phone, position, addressObj} = this.ruleForm;
          ClueService.clueCreate({
            compName: compName,
            province: addressObj[0],
            city: addressObj[1],
            district: addressObj[2],
            products,
            userName,
            phone,
            position,
          }).then(res => {
            if (res.code === 0) {
              Message.success("感谢您的推荐！");
              this.$refs.ruleForm.resetFields();
              this.$emit('recommdTipChange');
            }
            this.loading = false;
          }).catch(() => {
            this.loading = false;
          })
        } else {
          return false;
        }
      });
    },
    goChat() {
      this.$emit('recommdTipChange');
      // 入驻客户的id
      const userId = '221992398939168';
      ChatService.StartRecent(Category.User,userId)
    }
  },
}
</script>

<style lang="less" scoped>
  .recommd-desc{
    padding: 0px 22px;
    font-size: 14px;
    color: #606266;
    margin: 0px;
    text-indent: 2em;
    line-height: 22px;
  }
  .tip-text {
    font-size: 14px;
    color: #ff0000;
    text-align: center;
    margin: 10px;
  }
  .recommd-comp{
    width: 0;
    transition: all 0.3s;
    position: relative;
    overflow: hidden;
    box-shadow: -3px 0 12px rgba(0, 0, 0, 0.1);
    .comp-box {
      width: 410px;
      border-left: 1px solid #D6D6D6;
    }
    /deep/ .el-icon-close{
      display: block;
      position: absolute;
      right: 0;
      top: 0;
      width: 36px;
      height: 36px;
      text-align: center;
      line-height: 36px;
      font-size: 18px;
      cursor: pointer;
    }
    &>div{
      height: calc(100vh - 64px);
      overflow-y: auto;
      overflow-x: hidden;
    }

    .demo-ruleForm{
      padding: 16px 36px 0 20px;
      /deep/ .el-input--mini .el-input__inner{
        height: 32px;
        line-height: 30px;
      }
      /deep/ .el-form-item--small.el-form-item{
        margin-bottom: 10px;
      }
      /deep/ .el-form--label-top .el-form-item__label{
        padding-bottom: 0;
      }
      /deep/ .el-form-item--small .el-form-item__label {
        line-height: 22px;
      }
    }
    .submit-btn{
      text-align: center;
    }
  }
  .recommd-comp.active{
    width: 410px;
  }
  // 主页使用
  .recommd-comp-left {
    .recommd-desc {
      margin-bottom: 20px;
      line-height: 24px;
    }
    /deep/.el-form--label-left .el-form-item__label {
      text-align: right;
    }
    .submit-btn{
      margin-top: 20px;
      text-align: center;
    }
  }
</style>
